import { Point, utils } from '@gush/candybar';
import { COLORS } from './colors';

const { getRandomFloat, getRandomInt } = utils;

// physics
const GRAVITY = 1;
const FRICTION = 0.15; // 0 - 1
const DEPTH = 2; // 0 - ?

// cannon
const MIN_POWER = 200;
const MAX_POWER = 700;
const ANGLE_SPREAD = Math.PI / 3; // 0 - 2pi

// confetti
const CONFETTI_WIDTH = 10;
const CONFETTI_LENGTH = 10;
const CONFETTI_FLUTTER_MIN = 0.1;
const CONFETTI_FLUTTER_MAX = 0.3;

const AREA_BUFFER = 50; // extends active area around bounds to determine when dead

const BLUE = [
    COLORS.blue.lightest,
    COLORS.blue.light,
    COLORS.blue.DEFAULT,
    COLORS.blue.dark,
];

const RED = [COLORS.red.light, COLORS.red.DEFAULT, COLORS.red.dark];

const CONFETTI_COLORS = [
    // COLORS.black.lightest,
    // COLORS.black.inactive,
    // COLORS.black.lighter,
    COLORS.black.DEFAULT,
    // COLORS.black.pure,
    // COLORS.white.dark,
    // COLORS.white.background,
    COLORS.white.DEFAULT,
    COLORS.blue.lightest,
    // COLORS.blue.light,
    COLORS.blue.DEFAULT,
    COLORS.blue.dark,
    COLORS.red.light,
    COLORS.red.DEFAULT,
    // COLORS.red.dark,
    COLORS.purple.light,
    COLORS.purple.DEFAULT,
    // COLORS.purple.dark,
    COLORS.pink.light,
    // COLORS.pink.DEFAULT,
    // COLORS.pink.dark,
    COLORS.yellow.DEFAULT,
    // COLORS.yellow.dark,
    COLORS.green.light,
    COLORS.green.DEFAULT,
    // COLORS.green.dark,
];

export default class Confetti {
    constructor({ x, y, power, angle }) {
        this.x = x;
        this.y = y;
        this.power = power;
        this.angle = angle;
    }

    setup = ({ dpr }) => {
        this.length = CONFETTI_LENGTH * dpr;
        this.width = CONFETTI_WIDTH * dpr;
        this.color =
            CONFETTI_COLORS[getRandomInt(0, CONFETTI_COLORS.length - 1)];

        const halfSpread = ANGLE_SPREAD / 2;
        const angle = getRandomFloat(
            this.angle - halfSpread,
            this.angle + halfSpread
        );

        this.incremental = getRandomFloat(
            CONFETTI_FLUTTER_MIN,
            CONFETTI_FLUTTER_MAX
        );

        this.cos = getRandomFloat(0, Math.PI * 2);

        this.friction = 1 - FRICTION;
        this.gravity = GRAVITY * dpr + getRandomFloat(0, DEPTH);

        const distance = getRandomFloat(
            this.power * MIN_POWER * dpr,
            this.power * MAX_POWER * dpr
        );
        this.velocity = new Point(0, 0).moveAtAngle(angle, distance);
    };

    draw = ({ ctx }) => {
        if (this.dead) return;

        ctx.beginPath();
        ctx.lineWidth = this.width + this.spin;
        ctx.strokeStyle = this.color;
        const x1 = this.x + this.tilt;
        const y1 = this.y - this.tilt;
        const x2 = this.x + this.tilt + this.length;
        const y2 = this.y + this.tilt;
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
    };

    update = ({ bounds, pointer, dpr }) => {
        if (this.dead) return;

        // pointer effects
        const dist = pointer.position.distance({
            x: this.x,
            y: this.y,
        });
        const maxDist = (dpr * 25) / this.incremental;
        if (dist < maxDist) {
            let vx = dist * 0.003 * dpr;
            let vy = dist * 0.003 * dpr;
            if (this.x < pointer.position.x) {
                vx *= -1;
            }
            if (this.y < pointer.position.y) {
                vy *= -1;
            }
            this.velocity.x += vx;
            this.velocity.y += vy;
        }

        // gravity/friction
        this.velocity.x *= this.friction;
        this.velocity.y += this.gravity * this.friction;
        this.velocity.y *= this.friction;

        this.cos += this.incremental;
        this.spin = Math.cos(this.cos) * (this.width / 2);
        this.tilt = Math.sin(this.cos) * (this.length / 2);

        this.x += this.velocity.x;
        this.y += this.velocity.y;
        if (
            this.y > bounds.h + AREA_BUFFER ||
            this.x > bounds.w + AREA_BUFFER ||
            this.x < -AREA_BUFFER
        ) {
            this.dead = true;
        }
    };
}
